import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

const RawMaterialPricingView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({}); 
   const [permission, setPermission] = useState({});

 const primaryCurrency =  [
    {
        "label": "EUR",
        "value": 1,
        "symbol": "€",
        "key": "cabrane-0"
    },
    {
        "label": "USD",
        "value": 2,
        "symbol": "$",
        "key": "cabrane-1"
    },
    {
        "label": "GBP",
        "value": 3,
        "symbol": "£",
        "key": "cabrane-2"
    },
    {
        "label": "MAD ",
        "value": 4,
        "symbol": "dh",
        "key": "cabrane-3"
    }
];
   let season_id = localStorage.getItem("season_id");

  const [currencySymbol, setCurrencySymbol] = useState('');
  useEffect(() => {
        setPermission(FindModuleById(191)); 
console.log(permission);

   
     axios
      .get(`/raw-materials/view/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.raw);
          console.log(response.data.data.raw);
          const currencydetail = primaryCurrency.find(item => item.value === response.data.data.raw.currency) || null;
          setCurrencySymbol(currencydetail ? currencydetail.symbol : 'dh');
          
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  let raw_data_invoice ='';
  if(value.invoice){
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: value.invoice};
    raw_data_invoice = s3.getSignedUrl('getObject', params);
  
  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Raw Material Pricing</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/raw-material-pricing">Raw Material Pricing</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Raw Material
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {permission && permission.update == 1 && (
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">View Raw Material Info</h4>
                    <table className="table table-bordered">
                    <tr>
                        <th className="p-3">Lot Number</th>
                        <td className="p-3">{value.lot_number}</td>
                      </tr> <tr>
                        <th className="p-3">Plate Number</th>
                        <td className="p-3">{value.plate_number}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Driver Name</th>
                        <td className="p-3">{value.driver_name}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Farmer Name</th>
                        <td className="p-3">
                          {value.farmer_detail ? value.farmer_detail.name : ""}
                        </td>
                      </tr>
                      {/* <tr>
                        <th className="p-3">Supplier Location</th>
                        <td className="p-3">
                          {value.farmer_detail ? value.farmer_detail.location : ""}
                        </td>
                      </tr> */}
                      {/* <tr>
                        <th className="p-3">Former Name</th>
                        <td className="p-3">{value.former_name}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Form Location</th>
                        <td className="p-3">{value.form_location}</td>
                      </tr> */}
                      {/* <tr>
                        <th className="p-3">Product</th>
                        <td className="p-3">
                          {value.product ? value.product_name.name : ""}
                        </td>
                      </tr> */}
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">
                          {value.location ? value.location_name.title : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Shift Date</th>
                        <td className="p-3">{value.shift_date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Supplier Name</th>
                        <td className="p-3">
                          {value.supplier ? value.supplier_name.name : ""}
                        </td>
                      </tr>
                      {/* <tr>
                        <th className="p-3">BL Number</th>
                        <td className="p-3">{value.bl_number}KG</td>
                      </tr> */}
                      <tr>
                        <th className="p-3">BL Net Weight</th>
                        <td className="p-3">{value.net_weight}KG</td>
                      </tr>
                      <tr>
                        <th className="p-3">BL Gross Weight</th>
                        <td className="p-3">{value.gross_weight}KG</td>
                      </tr>
                      {/* <tr>
                        <th className="p-3">Number of Boxes</th>
                        <td className="p-3">{value.number_of_boxes}KG</td>
                      </tr> */}
                      {/* <tr>
                        <th className="p-3">Decay Net Weight</th>
                        <td className="p-3">{value.decay_net_weight}KG</td>
                      </tr> */}
                      <tr>
                        <th className="p-3">Date Time</th>
                        <td className="p-3">{value.date_time}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Incoming Status</th>
                        <td className="p-3">
                          {value.incoming_status
                            ? value.incoming_status_title.title
                            : ""}
                        </td>
                      </tr>

                      <tr>
                        <th className="p-3">Paid From</th>
                        <td className="p-3">
                          {(value.payment_from == 2)? 'Farmer' : "Export Optimum"}
                        </td>
                      </tr>

                      <tr>
                        <th className="p-3">Decay Price</th>
                        <td className="p-3">{parseFloat(value.decay_price).toFixed(2)}{currencySymbol}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Price</th>
                        <td className="p-3">{parseFloat(value.price).toFixed(2)}{currencySymbol}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Transport Cost</th>
                        <td className="p-3">{parseFloat(value.transport_cost).toFixed(2)}{currencySymbol}</td>
                      </tr>
                      
                      <tr>
                        <th className="p-3">Origin</th>
                        <td className="p-3">{value.origin}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Workers Cost</th>
                        <td className="p-3">{parseFloat(value.workers_cost).toFixed(2)}{currencySymbol}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Cabrane</th>
                        <td className="p-3">{parseFloat(value.cabrane).toFixed(2)}{currencySymbol}</td>
                      </tr>

                      <tr>
                        <th className="p-3">Total Amount</th>
                        <td className="p-3">{parseFloat(value.total_amount).toFixed(2)}{currencySymbol}</td>
                      </tr>

                      
                      <tr>
                        <th className="p-3">Rebate</th>
                        <td className="p-3">{value.rebate}%</td>
                      </tr>
                      <tr>
                        <th className="p-3">Payment Status</th>
                        <td className="p-3">
                          {value.payment_status
                            ? value.payment_status_title.title
                            : "Pending"}
                        </td>
                      </tr>
                      

                      {raw_data_invoice != '' && (
                          <tr>
                          <th className="p-3">Invoice</th>
                          <td className="p-3">
                            <a
                              className="btn btn-primary invoicebtn"
                              href={raw_data_invoice}
                              target="_blank"
                              download
                              rel="noopener noreferrer"

                            >
                              Download
                            </a>
                          </td>
                        </tr>
                      )}
                        <tr>
                                  <th className="p-3" colSpan={2}><h3>Quality Check </h3></th>
                                </tr>
                              <tr>
                                  <th className="p-3">Calibre Dominant</th>
                                  <td className="p-3">{value.quality_check_calibre_dominant}</td>
                                </tr>
                                <tr>
                                  <th className="p-3 ">Petit Calibre</th>
                                  <td className="p-3">{value.quality_check_petit_calibre}</td>
                                </tr>
                                <tr>
                                <th className="p-3 ">Dechet</th>
                                <td className="p-3">{value.quality_check_dechet}</td>
                                </tr>
                             
                                <tr>
                                <th className="p-3 ">Status</th>
                                <td className="p-3">
                                  {value.check_status
                            ? value.check_status.title
                            : ""}
                                  </td>
                                </tr>
                                <tr>
                                <th className="p-3 ">Remarks</th>
                                <td className="p-3">{value.quality_check_remarks}</td>
                                </tr>

                    </table>
                  </div>
                </div>
              </div>
            </div> )}
                {permission && permission.update == 1 && (
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <h5 className="card-title">Palletesation Details:  {(value.palletesation && value.palletesation.length)?value.palletesation.length:0}</h5>

                            <table className="table table-bordered text-center">
                                  <thead>
                                  <tr>
                                    <th className="p-3">Barcode</th>
                                    <th className="p-3">Gross Weight</th>
                                    <th className="p-3">Net Weight</th>
                                    <th className="p-3">Number Of Boxes</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  {value.palletesation &&
                                  value.palletesation.map((item, indx) => (
                                    <tr  key={item.raw_material_id || indx}>
                                      <td className="p-3">
                                      
                                        <a href={'/raw-materials-view/'+item.raw_material_id} className=""  >
                                              {item.barcode}
                                            </a>
                                        </td>
                                        <td className="p-3">{item.gross_weight}KG</td>
                                        <td className="p-3">{item.net_weight}KG</td>
                                      <td className="p-3">{item.number_of_boxes}</td>
                                    </tr>
                                  ))}
                                  
                                  </tbody>
                              
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                )}
          </div>
        </div>
      </div>
    </>
  );
};
export default RawMaterialPricingView;
